"use client";

import React from "react";
import EditSection from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";
import { Input } from "rizzui";
import { Select } from "@/components/ui/select";
import { PiTrash, PiPlusBold, PiX, PiUploadSimple } from "react-icons/pi";

export default function CollegeHeaderEdit({
  content,
  onContentChange,
  allSections = [],
}: SectionContentProps & { allSections?: any[] }) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  const navItems = content.navItems || [
    { label: "About", sectionId: "about" },
    { label: "Programs", sectionId: "programs" },
    { label: "Admissions", sectionId: "admissions" },
    { label: "Campus", sectionId: "campus" },
    { label: "Contact", sectionId: "contact" }
  ];

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="bg-slate-50 rounded-xl p-4 border border-slate-200 space-y-4">
            {/* Logo brand */}
            <div>
              <label className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2 block">
                Logo / Brand
              </label>
              <Input
                value={content.logo || ""}
                onChange={(e) => updateContent("logo", e.target.value)}
                placeholder="COLLEGE"
                className="!rounded-lg"
              />
            </div>

            {/* Navigation list */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="text-xs font-semibold text-gray-700 uppercase tracking-wide">
                  Navigation Items
                </label>
                <button
                  onClick={() => {
                    updateContent("navItems", [...navItems, { label: "New Link", sectionId: "hero" }]);
                  }}
                  className="text-xs text-blue-600 hover:text-blue-700 font-semibold flex items-center gap-1"
                >
                  <PiPlusBold className="w-3 h-3" /> Add
                </button>
              </div>

              <div className="space-y-3">
                {navItems.map((item: any, idx: number) => {
                  const navItem = typeof item === "string" ? { label: item, sectionId: item.toLowerCase() } : item;
                  return (
                    <div key={idx} className="bg-white p-3 rounded-lg border border-gray-200 flex gap-2 relative shadow-xs">
                      <div className="flex-1 grid grid-cols-2 gap-2">
                        <Input
                          value={navItem.label || ""}
                          onChange={(e) => {
                            const current = [...navItems];
                            current[idx] = { ...navItem, label: e.target.value };
                            updateContent("navItems", current);
                          }}
                          className="!rounded-md text-xs"
                          placeholder="Home"
                        />
                        <Select
                          value={navItem.sectionId || "hero"}
                          onChange={(val: any) => {
                            const v = val?.target?.value || val?.value || val;
                            const current = [...navItems];
                            current[idx] = { ...navItem, sectionId: v };
                            updateContent("navItems", current);
                          }}
                          options={[
                            ...(allSections || [])
                              .filter(s => s && s.type !== "header" && s.type !== "footer")
                              .map((sec, i) => ({
                                label: `${i + 1}. ${sec.title || sec.type}`,
                                value: sec.type
                              })),
                            { label: "Custom Link", value: "custom" }
                          ]}
                          className="w-full text-xs !rounded-md"
                        />
                      </div>
                      <button
                        onClick={() => {
                          const current = navItems.filter((_: any, i: number) => i !== idx);
                          updateContent("navItems", current);
                        }}
                        className="self-center p-1.5 text-gray-400 hover:text-red-500 rounded-md hover:bg-red-50"
                      >
                        <PiTrash className="w-4 h-4" />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Header CTA Button */}
            <div>
              <label className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5 block">
                CTA Button Text
              </label>
              <Input
                value={content.ctaText || "Apply Now"}
                onChange={(e) => updateContent("ctaText", e.target.value)}
                placeholder="Apply Now"
                className="!rounded-lg"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-1.5 block">
                CTA Button Link
              </label>
              <Input
                value={content.ctaLink || ""}
                onChange={(e) => updateContent("ctaLink", e.target.value)}
                placeholder="#apply"
                className="!rounded-lg"
              />
            </div>
          </div>
        </div>
      }
    />
  );
}
